"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalDataStore = void 0;
const identifiers_1 = require("../../identifiers");
const utils_1 = require("@streamr/utils");
class LocalDataStore {
    maxTtl;
    constructor(maxTtl) {
        this.maxTtl = maxTtl;
    }
    // A map into which each node can store one value per data key
    // The first key is the key of the data, the second key is the
    // DhtAddress of the creator of the data
    store = new Map();
    storeEntry(dataEntry) {
        const key = (0, identifiers_1.toDhtAddress)(dataEntry.key);
        const creatorNodeId = (0, identifiers_1.toDhtAddress)(dataEntry.creator);
        if (!this.store.has(key)) {
            this.store.set(key, new utils_1.MapWithTtl((e) => Math.min(e.ttl, this.maxTtl)));
        }
        if (this.store.get(key).has(creatorNodeId)) {
            const storedMillis = (dataEntry.createdAt.seconds * 1000) + (dataEntry.createdAt.nanos / 1000000);
            const oldLocalEntry = this.store.get(key).get(creatorNodeId);
            const oldStoredMillis = (oldLocalEntry.createdAt.seconds * 1000) + (oldLocalEntry.createdAt.nanos / 1000000);
            // do nothing if old entry is newer than the one being replicated
            if (oldStoredMillis >= storedMillis) {
                return false;
            }
        }
        this.store.get(key).set(creatorNodeId, dataEntry);
        return true;
    }
    markAsDeleted(key, creator) {
        const item = this.store.get(key);
        if (!item?.has(creator)) {
            return false;
        }
        const storedEntry = item.get(creator);
        storedEntry.deleted = true;
        return true;
    }
    *values(key) {
        if (key !== undefined) {
            const map = this.store.get(key);
            if (map !== undefined) {
                yield* map.values();
            }
        }
        else {
            for (const v of this.store.values()) {
                yield* v.values();
            }
        }
    }
    keys() {
        return this.store.keys();
    }
    setAllEntriesAsStale(key) {
        this.store.get(key)?.forEach((value) => {
            value.stale = true;
        });
    }
    deleteEntry(key, creator) {
        const storedEntry = this.store.get(key)?.get(creator);
        if (storedEntry) {
            this.store.get(key)?.delete(creator);
            if (this.store.get(key)?.size() === 0) {
                this.store.delete(key);
            }
        }
    }
    clear() {
        this.store.forEach((value) => value.clear());
        this.store.clear();
    }
}
exports.LocalDataStore = LocalDataStore;
//# sourceMappingURL=LocalDataStore.js.map